import PC from './pc';
import H5 from './h5';

export default isMobile ? H5 : PC;
